import * as React from "react"
import { motion } from "motion/react"

// Chip color based on highest denomination in amount (matching ChipStack palette)
const getChipColor = (amount: number) => {
  if (amount >= 500) return { bg: "#9B59B6", border: "#7D3C98" }
  if (amount >= 100) return { bg: "#1A1A1A", border: "#444444" }
  if (amount >= 25) return { bg: "#22C55E", border: "#16A34A" }
  if (amount >= 10) return { bg: "#3B82F6", border: "#2563EB" }
  if (amount >= 5) return { bg: "#EF4444", border: "#DC2626" }
  return { bg: "#F5F5F5", border: "#D4D4D4" }
}

export type FlyingChipData = {
  id: string
  fromTop: string
  fromLeft: string
  amount: number
  delay: number
}

// Animated chip that flies from a player seat to the pot center
export const FlyingChip = ({
  fromTop,
  fromLeft,
  amount,
  delay = 0,
  duration = 0.5,
  onComplete,
}: {
  fromTop: string
  fromLeft: string
  amount: number
  delay?: number
  duration?: number
  onComplete: () => void
}) => {
  const { bg, border } = getChipColor(amount)

  return (
    <motion.div
      className="absolute -translate-x-1/2 -translate-y-1/2 z-30 pointer-events-none"
      initial={{ top: fromTop, left: fromLeft, scale: 1, opacity: 1 }}
      animate={{
        top: "35%",
        left: "50%",
        scale: [1, 1.3, 0.7],
        opacity: [1, 1, 0],
      }}
      transition={{
        duration,
        delay,
        ease: [0.25, 0.46, 0.45, 0.94],
      }}
      onAnimationComplete={onComplete}
    >
      <div
        className="w-5 h-5 md:w-6 md:h-6 rounded-full"
        style={{
          backgroundColor: bg,
          border: `2px solid ${border}`,
          boxShadow:
            "0 2px 6px rgba(0,0,0,0.5), inset 0 1px 2px rgba(255,255,255,0.2)",
        }}
      />
    </motion.div>
  )
}
